var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedVideoIconWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F3F3F3",
  d: "M.5.5h23v15H.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h6v16H0V0Z",
  fill: "#F3F3F3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1h4v4H1V1ZM1 6h4v4H1V6ZM1 11h4v4H1v-4Z",
  fill: "#5A0066"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 0h6v16h-6V0Z",
  fill: "#F3F3F3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M19 1h4v4h-4V1ZM19 6h4v4h-4V6ZM19 11h4v4h-4v-4Z",
  fill: "#5A0066"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m15 8-4.5 2.598V5.402L15 8Z",
  fill: "#F3F3F3"
})));
export default SvgFeedVideoIconWhite;